<template>
  <div>
    <h5 class="account_title">
      {{ $t("Bao.transaction-index") }}
    </h5>
    <ul class="quick_btn_area four list-unstyled">
      <li>
        <a :class="classObject('main')" @click="goPath('/transaction')">{{ $t("Bao.main_wallet_detail") }}</a>
      </li>
      <li>
        <a :class="classObject('commission')" @click="goPath('/transaction/commission')">{{ $t("Bao.commission_wallet_detail") }}</a>
      </li>
      <li>
        <a :class="classObject('deposit-record')" @click="goPath('/payment/deposit-record')">{{ $t("Bao.deposit_detail") }}</a>
      </li>
      <li>
        <a :class="classObject('withdrawal-record')" @click="goPath('/payment/withdrawal-record')">{{ $t("Bao.withdrawal_detail_2") }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AccountDetail',
  props: {
    'tabName': {
      type: String,
      default: ''
    }
  },
  methods: {
    classObject: function(tabName) {
      let classDesc = 'btn btn_quick d-flex align-items-center justify-content-center w-100 '
      if (this.tabName === tabName) {
        classDesc += ' active'
      }
      return classDesc
    },
    goPath(path) {
      if (this.$router.currentRoute.path.indexOf('/web') >= 0) {
        this.$router.push('/web' + path)
      } else {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>

</style>
